export default __webpack_public_path__ + "static/media/NewDashActive.9e3b9f41.svg";